<script setup lang="ts">
import { computed } from "vue";

const page = usePage();
const nutrition = computed(() => page.value?.nutrition ?? []);
const currentSlide = ref(0);
</script>

<template>
  <div id="nutrition">
    <header>
      <h2>Nutrition and Hydration</h2>
    </header>

    <Carousel
      v-model="currentSlide"
      :items-to-show="1"
      :items-to-scroll="1"
      :wrap-around="false"
    >
      <Slide v-for="slide in nutrition" :key="slide.id">
        <div class="carousel__item">
          <div class="nutrition-image">
            <NuxtPicture
              loading="lazy"
              :src="slide?.nutritionimage?.url"
              :width="slide?.nutritionimage?.width"
              :height="slide?.nutritionimage?.height"
              :alt="slide?.nutritionimage?.alt"
              sizes="sm:400px md:500px lg:700px"
            />
          </div>
          <div class="nutrition-info">
            <h3>{{ slide?.nutritioninfo }}</h3>
            <div v-html="slide?.text" />
          </div>
        </div>
      </Slide>
      <template #addons>
        <Navigation />
        <Pagination />
      </template>
    </Carousel>
  </div>
</template>
